import { Button } from '@cian/ui-kit/button';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from 'shared/actions/authentication';
import { trackOnlineBookingBookButtonClick } from 'shared/containers/AsideContacts/OnlineBookingBookButtonContainer/tracking';
import { useDailyrentCheckoutPageUrl } from 'shared/hooks/useDailyrentCheckoutPageUrl';
import { selectOfferId, selectUser } from 'shared/selectors';
import { selectDailyrentBookingGeneral } from 'shared/selectors/dailyrentBooking';

export const OnlineBookingBookButtonContainer = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const realtyId = useSelector(selectOfferId);
  const { isLoading } = useSelector(selectDailyrentBookingGeneral);

  const checkoutPageUrl = useDailyrentCheckoutPageUrl();

  const onClick = React.useCallback(() => {
    const goToCheckoutPage = () => window.open(checkoutPageUrl, '_blank', 'noopener,noreferrer');

    trackOnlineBookingBookButtonClick(realtyId);

    if (!user?.isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: () => goToCheckoutPage,
        }),
      );
    } else {
      goToCheckoutPage();
    }
  }, [realtyId, user, checkoutPageUrl, dispatch]);

  return (
    <Button onClick={isLoading ? undefined : onClick} role="button" theme="fill_primary" size="M" fullWidth>
      Забронировать
    </Button>
  );
};
